export default __webpack_public_path__ + "static/media/logo-masamune-full-white.7fdfc0d4.svg";